import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { SystemLogSeverityOption } from '../system-logs-severity-option.interface';

export const systemLogSeverityOptionActions = createEagerSelectActions<SystemLogSeverityOption>(
   '[System Log Severity Options]'
);
